// EQG-MOB-05 — offline inspection submit queue. Finishing offline is a success:
// stored locally, flushed when signal returns.
import { mobileApi } from './api';

const KEY = 'mobile_inspection_queue';
const EVENT = 'inspqueuechange';

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
const write = (list) => { localStorage.setItem(KEY, JSON.stringify(list)); window.dispatchEvent(new Event(EVENT)); };

export const inspectionQueueCount = () => read().length;

export const enqueueInspection = (payload) => {
  const list = read();
  list.push({ id: `i_${Date.now()}`, payload, queued_at: new Date().toISOString() });
  write(list);
  return list.length;
};

let flushing = false;
export const flushInspectionQueue = async (token) => {
  if (flushing || !navigator.onLine) return;
  const list = read();
  if (list.length === 0) return;
  flushing = true;
  const remaining = [];
  for (const item of list) {
    try { await mobileApi.submitInspection(item.payload, token); }
    catch { remaining.push(item); }
  }
  write(remaining);
  flushing = false;
};

export const onInspectionQueueChange = (cb) => {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
};
